import React from 'react';

/**
 * 特定のメールアドレス入力で警告を出すメールアドレス入力
 */
export default function EmailInput({
  id = undefined,
  className = undefined,
  name = undefined,
  placeholder = undefined,
  value = undefined,
  defaultValue = undefined,
  onChange = undefined,
}: {
  id?: string,
  className?: string,
  name?: string,
  placeholder?: string,
  value?: string,
  defaultValue?: string,
  onChange?: (value: string) => void,
}) {
  const [warning, setWarning] = React.useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (onChange) {
      onChange(value);
    }
    const patterns = [
      /softbank/,
      /ezweb/,
      /docomo/,
      /vodafone/,
      /@yahoo\.co\.jp/,
      /@ymobile\.ne\.jp/,
      /@yahoo\.ne\.jp/,
      /@me\.com/,
      /@live\.jp/,
      /@pdx\.ne\.jp/,
    ];
    for (let i = 0; i < patterns.length; i++) {
      if (value.match(patterns[i])) {
        setWarning(true);
        return;
      }
    }
    setWarning(false);
  }

  const props2: { [key: string]: string } = {};
  if (id !== undefined) {
    props2.id = id;
  }
  if (name !== undefined) {
    props2.name = name;
  }
  if (value !== undefined) {
    props2.value = value;
  }
  if (defaultValue !== undefined) {
    props2.defaultValue = defaultValue;
  }
  if (placeholder !== undefined) {
    props2.placeholder = placeholder;
  }
  let actualClassName = 'current_caution';
  if (typeof className !== 'undefined') {
    actualClassName += ` ${className}`;
  }
  let warningStyle = { display: 'none' };
  let inputStyle = { border: '1px solid #D4D4D4' };
  if (warning) {
    warningStyle = { display: 'block' };
    inputStyle = { border: '1px solid #ff873c' };
  }
  return (
    <span>
      <input type="text" className={actualClassName} style={inputStyle} onChange={(e) => { handleChange(e); }} {...props2} />
      <p className="text_error_caution" style={warningStyle}>携帯電話のメールアドレスではメールが受け取れない場合があります。メールの受信設定で、受信許可リストに「@frekul.com」を追加してからご利用ください。</p>
    </span>
  );
}
